export default {
  halfWidthAndHeight: 40,
};



// WEBPACK FOOTER //
// ./src/components/ReactJS/constants.js